import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/home/Hero';
import Advantages from '../components/home/Advantages';
import HowItWorks from '../components/home/HowItWorks';
import ComparisonModule from '../components/home/ComparisonModule';
import Testimonials from '../components/home/Testimonials';
import PartnerBanks from '../components/home/PartnerBanks';
import ChatWidget from '../components/common/ChatWidget';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Advantages />
        <HowItWorks />
        <ComparisonModule />
        <PartnerBanks />
        <Testimonials />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default HomePage;
